import { useCallback, useRef, useState } from "react";

import { PIP_INTERACTIVE_ANIMS } from "../../constants/pipConfig";
import PipCharacter from "./PipCharacter";

const LABELS = {
  wave: "— waving hello 👋",
  jump: "— jumping for joy",
  spin: "— doing a full spin",
  wink: "— giving you a wink",
  dance: "— doing a little shimmy",
};

export default function PipInteractive({ size = 80, outfit = null }) {
  const [visualState, setVisualState] = useState("idle");
  const [animClass, setAnimClass] = useState("");
  const [label, setLabel] = useState("— waiting for a click");
  const lastAnim = useRef(null);

  const resetIdle = useCallback(() => {
    setVisualState("idle");
    setAnimClass("");
  }, []);

  const handleClick = () => {
    const choices = PIP_INTERACTIVE_ANIMS.filter((a) => a !== lastAnim.current);
    const anim = choices[Math.floor(Math.random() * choices.length)];
    lastAnim.current = anim;
    setLabel(LABELS[anim] || "");

    if (anim === "wave") {
      setVisualState("wave");
      setAnimClass("");
      setTimeout(resetIdle, 1000);
    } else if (anim === "jump") {
      setVisualState("found");
      setAnimClass("pip-anim-jump");
      setTimeout(resetIdle, 1000);
    } else if (anim === "spin") {
      setVisualState("idle");
      setAnimClass("pip-anim-spin");
      setTimeout(resetIdle, 1000);
    } else if (anim === "wink") {
      setVisualState("idle");
      setAnimClass("");
      setTimeout(resetIdle, 1200);
    } else if (anim === "dance") {
      setVisualState("idle");
      setAnimClass("pip-anim-dance");
      setTimeout(resetIdle, 1400);
    }
  };

  return (
    <div className="pip-interactive-wrap" onClick={handleClick} role="button" tabIndex={0} onKeyDown={(e) => e.key === "Enter" && handleClick()}>
      <PipCharacter
        size={size}
        state={visualState}
        outfit={outfit}
        interactive
        animClass={animClass}
      />
      <span className="pip-interactive-label">{label}</span>
    </div>
  );
}
